"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Contingency funding planning
 *  - Limits on reports
 *  -- Maintain dictionary of metrics that Vichu defines
 *      - private vs public definitions
 *
 * Balance Sheet Simulation
 *   Actions
 *   - Give additional Loans
 *   - Lend through Cash Credits (Retail Account/CCOD)
 *   - Expect some positions to -> NPA(Non performing assets);
 *
 *  -  Choose by trade id
 *  - 20% handled by Customer Managed Data + Interface
 */
//# sourceMappingURL=user-record.js.map